import { PropsGeneral } from './../Data';
import { Color } from './../entities/Color';
import {
  PaneMaterial,
  NATURAL_COLOR,
  WHITE_COLOR,
  Material,
} from './../constants';
import { getPiecesData } from './dataStorage';
import { PiecesComponentsList } from '../entities/PiecesComponentsList';
import { KewloxPieceType } from '../pieces/CustomPiece';

export function findPieceByRef(
  reference: string,
  piecesComponentsList?: PiecesComponentsList<KewloxPieceType>,
) {
  if (!piecesComponentsList) {
    piecesComponentsList = getPiecesData().others;
  }
  const piece = piecesComponentsList.getFromReference(reference);
  if (!piece) {
    throw new Error(
      `The piece ${reference} don't exist in the category of PiecesComponentsList (Check the category and pieces.json)`,
    );
  }
  return piece;
}

export function computeWeightWithDensity(
  widthMM: number,
  heightMM: number,
  depthMM: number,
  density: number,
) {
  const widthMicr = widthMM / 1000;
  const heightMicr = heightMM / 1000;
  const depthMicr = depthMM / 1000;

  const volume = widthMicr * heightMicr * depthMicr;

  return volume * density;
}

export function computePiecePrice(
  customPiecePrice: number,
  basePrice: number,
  custom: boolean,
  calibrated: boolean,
  propsGen: PropsGeneral,
) {
  let price = customPiecePrice;

  if (custom) {
    if (calibrated) {
      // When custom and calibrated, use the base piece to compute price
      price = basePrice;
      price += propsGen.suppl * propsGen.coef;
    } else price += propsGen.bigSuppl * propsGen.coef;
  }

  return price;
}

export function getPropsKey(
  material: PaneMaterial | Material,
  color?: Color,
): string {
  let key = `${material}`;
  if (color && [NATURAL_COLOR, WHITE_COLOR].includes(color.reference)) {
    key += `[${color.reference}]`;
  }
  return key;
}

export function formatNumber(
  value: number,
  virgule = '.',
  thousenSeparator = ',',
  numberOfDecimal = 2,
): string {
  const val_string = value.toFixed(numberOfDecimal).toString();
  const tmp = val_string.split('.');
  let abs_val_string = tmp.length === 2 ? tmp[0] : val_string;
  const deci_string = `0.${tmp.length === 2 ? tmp[1] : 0}`.substr(2);
  const nb = abs_val_string.length;

  for (let i = 1; i < 4; i++)
    if (value >= Math.pow(10, 3 * i))
      abs_val_string =
        abs_val_string.substring(0, nb - 3 * i) +
        thousenSeparator +
        abs_val_string.substring(nb - 3 * i);

  if (value.toFixed(numberOfDecimal).indexOf('.00') !== -1)
    return abs_val_string;
  return (
    abs_val_string +
    virgule +
    (parseFloat(deci_string) > 0 ? deci_string : '00')
  );
}
